module.exports = __webpack_public_path__ + "img/Habib Bank.839bfbdd.png";